
//Import asset file(s) used by this module.
import AbstractInstaller from '../../../shared/src/ranj/app/core/AbstractInstaller.js';
import AppInstaller from '../../../shared/src/ranj/app/core/AppInstaller.js';
import AppModel from '../../../shared/src/ranj/app/core/AppModel.js';
import ContextEvent from "../../../shared/src/ranj/app/core/ContextEvent";
import ExitGameCommand from '../../../shared/src/ranj/app/core/ExitGameCommand.js';
import GameEvent from '../../../shared/src/ranj/app/core/GameEvent.js';
import SkinKeys from '../../../shared/src/ranj/app/ui/SkinKeys.js';
import InitPlatformAPIServiceTask from '../../../shared/src/ranj/equalture/platform/InitPlatformAPIServiceTask.js';
import InitLanguageTask from '../../../shared/src/ranj/equalture/startup/InitLanguageTask.js';
import ShowSplashScreenTask from '../../../shared/src/ranj/equalture/startup/ShowSplashScreenTask.js';
import LoadStartupAssetsTask from '../../../shared/src/ranj/app/startup/LoadStartupAssetsTask.js';
import '../../assets/skins/MainAssets.js';
import '../../assets/skins/SplashAssets.js';
import StartGameCommand from './problemsolving/controller/StartGameCommand.js';
import InitProblemSolvingGameTask from './problemsolving/core/InitProblemSolvingGameTask.js';
import GameConfig from './problemsolving/model/GameConfig.js';
import GameModel from './problemsolving/model/GameModel.js';
import TrackingController from './problemsolving/model/TrackingController.js';
import EndScreenMediator from './problemsolving/view/EndScreenMediator.js';
import GameScreenMediator from './problemsolving/view/GameScreenMediator.js';
import SplashLoadScreenMediator from './problemsolving/view/SplashLoadScreenMediator.js';
import TutorialOverlayMediator from './problemsolving/view/TutorialOverlayMediator.js';
import SaveModel from './problemsolving/model/SaveModel.js';
import SaveEvent from '../../../shared/src/ranj/equalture/savegame/SaveEvent.js';
import SaveCommand from '../../../shared/src/ranj/equalture/savegame/SaveCommand.js';
import SaveController from './problemsolving/controller/SaveController.js';
import InitPlayModeTask from '../../../shared/src/ranj/equalture/startup/InitPlayModeTask.js';



export default class MinigameInstaller extends AbstractInstaller {

    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        this._addAssetGroupsToList(AppInstaller.PRELOAD_ASSET_GROUPS, "SplashAssets");
        this._addAssetGroupsToList(AppInstaller.STARTUP_ASSET_GROUPS, "sounds", "common", "MainAssets");


        commands.add(ContextEvent.START_GAME, StartGameCommand);
        commands.add(GameEvent.EXIT, ExitGameCommand);

        injector.mapClass("appModel", AppModel, true);
        injector.mapClass("gameModel", GameModel, true);
        injector.mapClass("gameConfig", GameConfig, true);
        injector.mapValue("gameAssets", lib.MainAssets);
        injector.mapClass("trackingController", TrackingController, true);

        injector.mapValue("saveController", injector.createInstance(SaveController));

        injector.mapClass("saveModel", SaveModel, true);
        commands.add(SaveEvent.SAVE, SaveCommand);
        commands.add(SaveEvent.CLEAR, SaveCommand);

        this._addAssetGroupsToList(AppInstaller.PRELOAD_ASSET_GROUPS, "preload");

        this._addStartupTask(InitPlatformAPIServiceTask, "InitPlatformAPIServiceTask", 0);
        this._addStartupTask(InitLanguageTask, "InitLanguageTask", 0, ["InitPlatformAPIServiceTask"]);
        this._addStartupTask(InitProblemSolvingGameTask, "initGameTask", 0, ["InitLanguageTask"]);
        this._addStartupTask(LoadStartupAssetsTask, "LoadStartupAssetsTask", 30, ["InitLanguageTask"]);
        this._addStartupTask(InitPlayModeTask, "InitPlayModeTask", 0, ["InitLanguageTask"]);
        this._addStartupTask(ShowSplashScreenTask, "ShowSplashScreenTask", 0, ["InitPlayModeTask"]);
        

        SkinKeys.SPLASH_LOAD_SCREEN_SKIN = this._mapMediator(SplashLoadScreenMediator, lib.SplashAssets.SplashLoadScreenSkin);
        SkinKeys.GAME_SCREEN_SKIN = this._mapMediator(GameScreenMediator, lib.MainAssets.GameScreenSkin);
        SkinKeys.TUTORIAL_OVERLAY_SKIN = this._mapMediator(TutorialOverlayMediator, lib.MainAssets.TutorialOverlaySkin);
        SkinKeys.END_SCREEN_SKIN = this._mapMediator(EndScreenMediator, lib.MainAssets.EndScreenSkin);
    }

};
